module.exports = __webpack_public_path__ + "img/Weapon_265.d120b0e2.png";